<template>
    <div class="tw-flex-1">
        <section class="tw-bg-primary tw-pt-14 sm:tw-pt-20 md:tw-pt-28 tw-pb-48 sm:tw-pb-56 tw-text-white">
            <div class="tw-container">
                <div class="md:tw-grid tw-grid-cols-12 tw-grid-gap tw-text-center">
                    <div class="tw-col-start-2 tw-col-end-12">
                        <a href="https://fytocompass.nl/frie-vragenlijsten" target="_blank" rel="noopener noreferrer" class="hover:tw-no-underline tw-font-medium tw-text[0.5rem] p-2 tw-bg-beige tw-mx-auto tw-text-primary tw-inline-block tw-rounded-lg tw-mb-5">Doe de test en bekijk de risicoanalyse</a>
                        <h1>{{ page.template.header }}</h1>
                    </div>
                    <div class="tw-col-start-3 tw-col-end-11">
                        <div class="tw-text-white tw-text-sm sm:tw-text-lg">
                            {{ page.template.subtitle }}
                        </div>
                        <a href="https://fytocompass.nl/frie-vragenlijsten" target="_blank" rel="noopener noreferrer" class="tw-button tw-mt-5">
                            Test je kennis
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <section class="-tw-mt-40 tw-mb-10 sm:tw-mb-18 md:tw-mb-28">
            <div class="lg:tw-container tw-px-0">
                <div class="tw-scroll-p-5 max-lg:tw-px-5 tw-flex max-lg:tw-snap-x max-lg:tw-overflow-x-auto lg:tw-grid tw-grid-cols-4 tw-grid-gap">
                    <a
                        v-for="organism in headerOrganisms"
                        :key="organism.id"
                        :href="organism.url"
                        class="tw-transition hover:tw-scale-[1.02] tw-snap-start max-lg:tw-w-[calc(33.33%_-_2rem)] max-md:tw-w-[calc(50%_-_2rem)] max-sm:tw-w-[calc(100%_-_2rem)] tw-shrink-0 tw-basis-auto tw-relative tw-p-8 tw-rounded-4xl tw-overflow-clip tw-min-h-[25rem]"
                    >
                        <img class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover" :src="organism.active_image" :alt="organism.title">
                        <div class="tw-bg-white tw-rounded-xl tw-px-4 tw-py-2 tw-text-black tw-relative tw-inline-block">
                            {{ organism.title }}
                        </div>
                    </a>

                    <div class="tw-snap-start max-lg:tw-w-[calc(33.33%_-_2rem)] max-md:tw-w-[calc(50%_-_2rem)] max-sm:tw-w-[calc(100%_-_2rem)] tw-shrink-0 tw-basis-auto tw-bg-white tw-rounded-3xl tw-flex tw-flex-col tw-items-start tw-gap-4 tw-justify-between tw-p-6">
                        <div>
                            <div class="tw-text-2xl tw-font-semibold tw-text-primary tw-mb-2">
                                Q-organismen
                            </div>
                            <div class="tw-leading-relaxed tw-text-lg">
                                Weet jij wat Q-organismen zijn en welke schade ze kunnen aanrichten?
                            </div>
                        </div>
                        <a class="tw-button" href="/quarantaine-organismen/algemeen">Meer informatie</a>
                    </div>
                </div>
            </div>
        </section>
        <section class="tw-my-10 sm:tw-my-18 md:tw-my-20">
            <div class="container">
                <div class="md:tw-grid tw-grid-cols-3 tw-grid-gap">
                    <h2 class="!tw-text-primary">Wat zijn Q-organismen?</h2>
                    <div class="tw-col-span-2">
                        <div
                            class="md:tw-text-lg tw-text-sm"
                            v-html="page.template.organism_text"
                        />
                        <button v-if="false" class="tw-button">Meer informatie</button>
                    </div>
                </div>
            </div>
        </section>
        <section class="tw-my-20">
            <div class="tw-container">
                <div class="tw-rounded-4xl tw-bg-white tw-overflow-clip">
                    <div class="max-sm:tw-hidden sm:tw-flex tw-divide-x tw-divide-beige tw-border-b tw-border-beige">
                        <button
                            v-for="organism in organisms"
                            :key="organism.id"
                            @click="selectedOrganism = organism"
                            class="tw-w-full tw-p-6 tw-transition tw-cursor-pointer"
                            :class="selectedOrganism === organism ? 'tw-bg-primary tw-text-primary-300 tw-pointer-events-none' : 'tw-bg-white hover:tw-bg-primary/10'"
                        >
                            {{ organism.title }}
                        </button>
                    </div>
                    <div class="sm:tw-hidden tw-flex tw-flex-col tw-relative">
                        <button
                            @click="open = !open"
                            class="tw-w-full tw-flex tw-justify-between tw-items-center tw-gap-4 tw-p-6 tw-transition tw-cursor-pointer tw-bg-primary tw-text-primary-300"
                        >
                            {{ selectedOrganism.title }}
                            <i class="fa fa-chevron-down"></i>
                        </button>
                        <div
                            class="tw-divide-y tw-divide-beige tw-overflow-y-auto tw-transition-all tw-duration-500 tw-max-h-0 tw-absolute tw-top-full tw-w-full tw-border-b tw-border-beige tw-bg-white"
                            :class="{'tw-max-h-[12.5rem]' : open}"
                        >
                            <button
                                v-for="organism in organisms"
                                :key="organism.id"
                                @click="selectedOrganism = organism; open = false"
                                class="tw-w-full tw-p-6 tw-transition tw-cursor-pointer"
                                :class="selectedOrganism === organism ? 'tw-hidden' : 'tw-bg-white hover:tw-bg-primary/10'"
                            >
                                {{ organism.title }}
                            </button>
                        </div>
                    </div>
                    <div
                        v-if="selectedOrganism"
                        class="md:tw-flex tw-items-center tw-grid-gap tw-rounded-2xl tw-p-6 md:tw-p-12 lg:tw-p-16 max-md:tw-space-y-10 "
                    >
                        <div>
                            <img :src="selectedOrganism.image" :alt="selectedOrganism.title" class="tw-w-32">
                            <h2 class="!tw-text-primary !tw-text-2xl tw-font-semibold tw-mb-4">{{ selectedOrganism.title }}</h2>
                            <p class="tw-text-lg">{{ selectedOrganism.short_description }}</p>
                            <div class="tw-flex tw-gap-4">
                                <a
                                    v-if="selectedOrganism.has_questions"
                                    class="tw-button"
                                    :href="`/quarantaine-organismen/${selectedOrganism.slug}/vragenlijst`"
                                >
                                    Doe de test
                                </a>
                                <a
                                    class="tw-button tw-button--secondary"
                                    :href="`/quarantaine-organismen/${selectedOrganism.slug}`"
                                >
                                    Meer informatie
                                </a>
                            </div>
                        </div>
                        <div v-if="selectedOrganism.title !== 'Algemeen'" class="md:tw-max-w-xs tw-bg-beige tw-w-full tw-rounded-4xl tw-p-4">
                            <div class="tw-flex tw-flex-wrap">
                                <button
                                    class="tw-text-sm tw-font-medium tw-px-4 tw-py-3.5 tw-rounded-full cursor-pointer"
                                    :class="section === 'symptoms' ? 'tw-bg-white tw-pointer-events-none' : 'tw-bg-transparent hover:tw-bg-white/50'"
                                    @click="section = 'symptoms'">
                                    Symptomen
                                </button>
                                <button
                                    class="tw-text-sm tw-font-medium tw-px-4 tw-py-2 tw-rounded-full cursor-pointer"
                                    :class="section === 'damage' ? 'tw-bg-white tw-pointer-events-none' : 'tw-bg-transparent hover:tw-bg-white/50'"
                                    @click="section = 'damage'">
                                    Schade
                                </button>
                            </div>
                            <div v-if="section === 'symptoms'">
                                <img
                                    class="tw-my-4 tw-rounded-3xl"
                                    :src="selectedOrganism.symptoms_image"
                                    :alt="selectedOrganism.title"
                                >
                                <div
                                    class="tw-font-medium tw-text-sm"
                                    v-html="selectedOrganism.symptoms_text"
                                />
                            </div>
                            <div v-if="section === 'damage'">
                                <img
                                    class="tw-my-4 tw-rounded-3xl"
                                    :src="selectedOrganism.damage_image"
                                    :alt="selectedOrganism.title"
                                >
                                <div
                                    class="tw-font-medium tw-text-sm"
                                    v-html="selectedOrganism.damage_text"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="tw-bg-primary tw-py-20 tw-space-y-16 sm:tw-space-y-32">
            <div class="tw-container">
                <h2 class="!tw-text-white">Eerdere uitbraken</h2>
                <div class="tw-scroll-p-5 tw-snap-x tw-overflow-x-auto tw-space-x-4 tw-flex tw-items-stretch" ref="swiper">
                    <div
                        v-for="outbreak in outbreaks"
                        class="tw-snap-start tw-w-[calc(100%_-_2rem)] tw-shrink-0 tw-basis-auto tw-overflow-clip tw-flex tw-flex-col-reverse md:tw-grid tw-grid-cols-2 tw-gap-4 tw-bg-white tw-rounded-4xl tw-p-6"
                    >
                        <div class="sm:tw-bg-beige tw-rounded-4xl sm:tw-p-10 tw-flex tw-flex-col tw-justify-center">
                            <h3>{{ outbreak.title }}</h3>
                            <div
                                class="tw-text-lg"
                                v-html="outbreak.description"
                            />
                        </div>
                        <img
                            class="tw-rounded-4xl"
                            :src="outbreak.image"
                            :alt="outbreak.title"
                        >
                    </div>
                </div>
            </div>
            <div class="tw-container tw-text-white tw-space-y-16">
                <div v-for="(block, index) in content" :key="block.id" class="sm:tw-grid tw-flex tw-gap-10 tw-flex-col-reverse tw-grid-gap tw-grid-cols-12 tw-group">
                    <div class="tw-flex tw-flex-col tw-justify-center tw-col-span-6" :class="index % 2 === 0 ? 'tw-col-span-6' : 'tw-col-start-7 tw-col-end-13 tw-row-start-1'">
                        <h3 class="!tw-text-white">{{ block.title }}</h3>
                        <div class="tw-prose tw-prose-invert tw-max-w-none" v-html="block.text"/>
                    </div>
                    <div :class="index % 2 === 0 ? 'tw-col-start-8 tw-col-end-13' : 'tw-col-span-5'">
                        <img :src="block.image" :alt="block.title">
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
    organisms: {
      type: Array,
      required: true,
    },
    outbreaks: {
      type: Array,
      required: true,
    },
    content: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    selectedOrganism: null,
    section: 'symptoms',
    open: false,
  }),
  created() {
    this.selectedOrganism = this.organisms[0];
  },
  computed: {
    headerOrganisms() {
      return this.organisms.slice(0, 3);
    },
  },
};
</script>
